import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, string } from 'prop-types'

function Section({ title = '', className = '', children }) {
  return (
    <div className={classnames('more-filters__group', className)}>
      {title && (
        <div className="more-filters__column-title cgt-overline-md">
          {title}
        </div>
      )}
      {children}
    </div>
  )
}

Section.propTypes = {
  title: string,
  className: string,
  children: node.isRequired,
}

export default memo(Section)
